import React from 'react';

const GooglePlayButton = ({ buttonType }) => {
  const handleClick = () => {
    const storeURL = 'https://play.google.com/store/apps/details?id=com.vlending.apps.mubeat';
    window.open(storeURL, '_blank');
  };

  return (
    <button
      type='button'
      className={`button-default store-button playstore-button ${
        buttonType === buttonType ? `type-${buttonType}` : ''
      }`}
      onClick={handleClick}
    >
      <span className={'icon-group'}>
        <i className={`icon ${buttonType === buttonType ? `icon-playstore-${buttonType}` : 'icon-playstore'}`} />
      </span>
      Google Play
    </button>
  );
};

export default GooglePlayButton;
